module.exports = __webpack_public_path__ + "img/37.16faab35.png";